import {empty} from './strings';

export const urlParams = parseUrlParams();

/**
 * @param {string} [search]
 * @return {object}
 */
export function parseUrlParams(search = window.location.search) {
  const items = search.slice(search.indexOf('?') + 1).split('&').filter((x) => !!x);

  return items.reduce((params, item) => {
    const [key, val] = item.split('=');
    params[key] = decodeURIComponent(val);

    return params;
  }, {});
}

const queryStart = '?';

/**
 * @param {string} [url]
 * @param {string} [search]
 */
export function redirect(url = empty, search = window.location.search) {
  const [destPath = empty, destParams = empty] = url.split(queryStart);
  const currentParams = search || (destParams ? queryStart : empty);
  window.location.href = destPath + currentParams + (search && destParams ? '&' : empty) + destParams;
}
